import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import {
  IturanCarrierAdminCreate,
  CarrierAdminInfo,
  CarrierManagerCreateUser,
  CarrierManagerInfo,
  ShipperInfo,
  UserRead,
  IturanCarrierRead,
} from '../../models/user';
import { UserFilterEnum } from '../../enums/user';

export const userEvents = eventGroup({
  source: 'User',
  events: {
    clear: type<void>(),
    setLoading: type<boolean>(),

    // new api (ituran carriers)
    createIturanCarrierAdmin: type<IturanCarrierAdminCreate>(),
    createIturanCarrierAdminSuccess: type<boolean>(),
    createIturanCarrierAdminFailure: type<boolean>(),
    resetIturanCarrierCreateOutcome: type<void>(),
    loadItruanCarriers: type<{ pageSize?: number; page?: number }>(),
    loadedIturanCarriers: type<IturanCarrierRead[]>(),
    enableItruanCarrier: type<string>(),
    enableItruanCarrierSuccess: type<boolean>(),
    enableItruanCarrierFailure: type<boolean>(),

    disableItruanCarrier: type<string>(),
    disableItruanCarrierSuccess: type<boolean>(),
    disableItruanCarrierFailure: type<boolean>(),

    deleteIturanCarrier: type<string>(),
    deleteIturanCarrierSuccess: type<boolean>(),
    deleteIturanCarrierFailure: type<boolean>(),

    // old apis but still working
    createUser: type<CarrierManagerCreateUser>(),
    createUserSuccess: type<boolean>(),
    createUserFailure: type<boolean>(),
    updateUser: type<{
      parentSub: string;
      sub: string;
      payload: Record<string, unknown>;
    }>(),
    updateUserSuccess: type<boolean>(),
    updateUserFailure: type<boolean>(),
    deleteUser: type<{
      parentSub: string;
      deleteSub: string;
    }>(),
    deleteCarrierManager: type<{
      parentSub: string;
      deleteSub: string;
    }>(),
    loadUsers: type<{
      parentSub: string;
      search: string;
      filter: UserFilterEnum;
      limit: number;
    }>(),
    loadedUsers: type<UserRead[]>(),
    loadCarrierAdminInfo: type<string>(),
    loadedCarrierAdminInfo: type<CarrierAdminInfo | null>(),
    loadShipperInfo: type<string>(),
    loadedShipperInfo: type<ShipperInfo | null>(),
    loadCarrierManagerInfo: type<string>(),
    loadedCarrierManagerInfo: type<CarrierManagerInfo | null>(),
  },
});
